import { theme } from 'antd'
import type { CSSProperties } from 'react'

type DocumentTableDividerProps = {
  id: string
  publicId: string
  name: string
  count: number
}

const DocumentTableDivider = ({
  id,
  publicId,
  name,
  count,
}: DocumentTableDividerProps) => {
  const { token } = theme.useToken()

  const isFlagged = name === 'Shame User'

  const barStyle: CSSProperties = {
    ...styles.tableDividerStyle,
    backgroundColor: isFlagged ? token.colorErrorBg : token.colorBgContainer,
    border: isFlagged
      ? `2px solid ${token.colorErrorBorder}`
      : `1px solid ${token.colorBorderSecondary}`,
    borderRadius: isFlagged ? 5 : 2,
  }

  return (
    <div style={barStyle}>
      <div style={styles.nameContainerStyle}>
        {publicId && (
          <p
            style={{
              ...styles.publicIdLabelStyle,
              color: token.colorTextTertiary,
            }}
          >
            {publicId}
          </p>
        )}
        <p style={{ ...styles.nameLabelStyle, color: token.colorText }}>
          {name}
        </p>
        <p style={{ ...styles.idLabelStyle, color: token.colorTextTertiary }}>
          {id}
        </p>
      </div>
      <div style={styles.counterContainerStyle}>
        <p style={{ ...styles.counterLabelStyle, color: token.colorText }}>
          {count}
        </p>
      </div>
    </div>
  )
}

const styles: InlineStyles = {
  tableDividerStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 20,
    paddingLeft: 20,
    borderRadius: 2,
  },
  nameContainerStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  counterContainerStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'flex-end',
  },
  nameLabelStyle: {
    fontSize: 20,
    marginTop: 5,
    marginBottom: 5,
    flex: 0.4,
  },
  counterLabelStyle: {
    fontSize: 20,
    marginTop: 5,
    marginBottom: 5,
    paddingRight: 20,
  },
  publicIdLabelStyle: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 5,
    flex: 0.1,
  },
  idLabelStyle: {
    fontSize: 12,
    marginTop: 5,
    marginBottom: 5,
    flex: 0.4,
  },
}

export default DocumentTableDivider
